<script>
import { required } from "vuelidate/lib/validators";
import Multiselect from "vue-multiselect";
import VueDropify from "vue-dropify";
import draggable from "vuedraggable";
import Swal from "sweetalert2";
import Middleware from "@/helpers/middlewares";

import UserService from "@/helpers/APIService/user.service";
import { authComputed } from "@/state/helpers";
import errorHandler from "@/helpers/errorHandler";
import hotelService from "@/helpers/APIService/hotel.service";

export default {
  data() {
    return {
      plugins: [
        "advlist autolink link image lists charmap print preview hr anchor pagebreak spellchecker",
        "searchreplace wordcount visualblocks visualchars code fullscreen insertdatetime media nonbreaking",
        "save table contextmenu directionality emoticons template paste textcolor",
      ],
      toolbar:
        "insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image | print preview media fullpage | forecolor backcolor emoticons",
      options: {
        height: 300,
        style_formats: [
          { title: "Bold text", inline: "b" },
          { title: "Red text", inline: "span", styles: { color: "#ff0000" } },
          { title: "Red header", block: "h1", styles: { color: "#ff0000" } },
          { title: "Example 1", inline: "span", classes: "example1" },
          { title: "Example 2", inline: "span", classes: "example2" },
          { title: "Table styles" },
          { title: "Table row 1", selector: "tr", classes: "tablerow1" },
        ],
      },
      nearByPlace: {
        name: "",
        description: null,
        category: [],
        is_active: true,
        g_address: "",
        g_latitude: "",
        g_longitude: "",
        g_phone_number: "",
        g_website: "",
        g_rating: "",
        g_user_ratings_total: "",
        g_opening_time: "",
        g_distance: "",
        image: "",
      },
      submitted: false,
      is_btn_loading: false,
      isSaveAndAddNew: false,
      categoryOption: [],
      imagePreView: [],
      imageToSubmit: [],
      isImageUploading: false,
      isNearByPlaceBtnLoading: false,
      editId: "",
    };
  },
  components: {
    Multiselect,
    VueDropify,
    draggable,
  },
  props: {
    currentProps: Object,
  },
  emits: ["submitted", "cancelSubmit"],
  computed: {
    ...authComputed,
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: !this.editable,
        ghostClass: "ghost",
      };
    },
  },
  validations: {
    nearByPlace: {
      name: {
        required,
      },
      category: {
        required,
      },
    },
  },
  mounted() {
    this.getNearByPlaceCategoryList();
    this.setIfEdit();
  },
  methods: {
    getNearByPlaceCategoryList() {
      hotelService.getNearByPlaceCategory().then((response) => {
        response.map((item) => {
          this.categoryOption.push({
            id: item.id,
            name: item.name,
            slug_name: item.slug_name,
          });
        });
      });
    },
    // Method is use for maintained edit data display
    setIfEdit() {
      this.imagePreView = [];
      if (this.currentProps.isEdit) {
        this.editId = this.currentProps.selectedNearByPlace.id;
        this.imagePreView =
          this.currentProps.selectedNearByPlace.near_by_place_image;

        this.nearByPlace.name = this.currentProps.selectedNearByPlace.name;
        this.nearByPlace.category =
          this.currentProps.selectedNearByPlace.place_category;
        this.nearByPlace.g_address =
          this.currentProps.selectedNearByPlace.g_address;
        this.nearByPlace.g_latitude =
          this.currentProps.selectedNearByPlace.g_latitude;
        this.nearByPlace.g_longitude =
          this.currentProps.selectedNearByPlace.g_longitude;
        this.nearByPlace.g_phone_number =
          this.currentProps.selectedNearByPlace.g_phone_number;
        this.nearByPlace.g_website =
          this.currentProps.selectedNearByPlace.g_website;
        this.nearByPlace.g_rating =
          this.currentProps.selectedNearByPlace.g_rating + "⭐";
        this.nearByPlace.g_user_ratings_total =
          this.currentProps.selectedNearByPlace.g_user_ratings_total;
        this.nearByPlace.g_distance =
          this.currentProps.selectedNearByPlace.g_distance;
        setTimeout(() => {
          this.nearByPlace.g_opening_time =
            this.currentProps.selectedNearByPlace.g_opening_time;
          this.nearByPlace.description =
            this.currentProps.selectedNearByPlace.description;
        }, 500);
      }
    },
    // Method is for maintained submit event
    onSubmit() {
      this.submitted = true;
      this.is_btn_loading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.is_btn_loading = false;
        return;
      } else {
        let data = {
          hotel: this.hotel.id,
        };
        let placeCategory = [];
        this.nearByPlace.category.map((item) => {
          placeCategory.push(item.id);
        });
        this.nearByPlace.g_rating = this.nearByPlace.g_rating.replace("⭐", "");
        data = {
          ...data,
          ...this.nearByPlace,
          place_category: placeCategory,
        };
        if (this.currentProps.isEdit == false) {
          hotelService
            .addNearByPlace(data)
            .then(
              (nearByPlace) => {
                let near_by_place_image = [];
                if (this.imageToSubmit.length !== 0) {
                  this.imageToSubmit.map((image, index) => {
                    let nearByPlaceImages = new FormData();
                    nearByPlaceImages.append("near_by_place", nearByPlace.id);
                    nearByPlaceImages.append("image", image);
                    if (index == 0) {
                      nearByPlaceImages.append("is_thumbnail", true);
                    }
                    UserService.addNearByPlaceImage(
                      nearByPlace.id,
                      nearByPlaceImages
                    )
                      .then((infoServicesImages) => {
                        near_by_place_image.push(infoServicesImages);
                      })
                      .catch((error) => {
                        errorHandler(error);
                      });
                  });
                }
                if (this.isSaveAndAddNew) {
                  this.$emit("saveAndAddNew", {
                    ...nearByPlace,
                    near_by_place_image,
                  });
                  this.nearByPlace = {
                    name: "",
                    description: "",
                    category: "",
                  };
                } else {
                  this.$emit("submitted", {
                    ...nearByPlace,
                    near_by_place_image,
                  });
                }
                this.is_btn_loading = false;
                this.submitted = false;
              },
              (error) => {
                this.is_btn_loading = false;
                errorHandler(error);
              }
            )
            .catch((error) => {
              errorHandler(error);
            });
        } else {
          hotelService
            .updateNearByPlace(this.currentProps.selectedNearByPlace.id, data)
            .then(
              (nearByPlace) => {
                this.$emit("submitted", nearByPlace);
                this.is_btn_loading = false;
                this.submitted = false;
              },
              (error) => {
                this.is_btn_loading = false;
                errorHandler(error);
              }
            )
            .catch((error) => {
              errorHandler(error);
            });
        }
      }
    },
    // Method is use for save and add new nearByPlace continue
    saveAndAddNew() {
      this.isSaveAndAddNew = true;
      this.onSubmit();
    },
    // Method is use for cancel to add new nearByPlace
    cancelSubmit() {
      this.$emit("cancelSubmit");
      this.isSaveAndAddNew = false;
    },
    //Method is use for change image as thumbnail image
    changeThumbnailImageStatus(image) {
      UserService.updateNearByPlaceImage(image.near_by_place, image.id, {
        is_thumbnail: image.is_thumbnail,
      }).then(
        (response) => {
          this.$root.$emit("updateImageStatusInNearBy", response);
          this.imagePreView = this.imagePreView.map((image) => {
            if (image.id !== response.id) {
              image = { ...image, is_thumbnail: false };
            } else {
              image = { ...image, is_thumbnail: true };
            }
            return image;
          });
          Middleware.notification(
            "Thumbnail image successfully set !!",
            "success"
          );
        },
        (error) => {
          errorHandler(error);
        }
      );
    },
    // Method is use for delete image
    deleteImage(image, index) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          UserService.deleteNearByPlaceImage(
            image.near_by_place,
            image.id
          ).then(
            () => {
              this.$root.$emit("removeImageInNearBy", this.imagePreView[index]);
              this.imagePreView.splice(index, 1);
              Middleware.notification("Successfully deleted !!", "warning");
            },
            (error) => {
              errorHandler(error);
            }
          );
        }
      });
    },
    // Method is use for change near_by_place image
    onChoose: function (evt) {
      const imageData = new FormData();
      imageData.append("priority_order", evt.moved.newIndex + 1);
      UserService.updateNearByPlaceImage(
        evt.moved.element.near_by_place,
        evt.moved.element.id,
        imageData
      )
        .then(() => {
          Middleware.notification("Image position changed !!", "success");
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is use for maintained change image event
    changeNearByPlaceImage(event) {
      const imgURL = event[0] == undefined ? null : event[0];
      if (imgURL !== null && this.currentProps.isEdit) {
        this.isNearByPlaceBtnLoading = true;
        const nearByPlaceImages = new FormData();
        nearByPlaceImages.append("near_by_place", this.editId);
        nearByPlaceImages.append("image", imgURL);
        UserService.addNearByPlaceImage(this.editId, nearByPlaceImages).then(
          (nearByPlaceImages) => {
            this.imagePreView.push(nearByPlaceImages);
            this.$root.$emit("imageAddedInNearBy", nearByPlaceImages);
            this.nearByPlace.image = null;
            Middleware.notification("Uploaded Successfully !!", "success");

            this.isNearByPlaceBtnLoading = false;
            setTimeout(() => {
              document.querySelector(".has-icon").click();
            }, 500);
          },
          (error) => {
            this.isNearByPlaceBtnLoading = false;
            errorHandler(error);
          }
        );
      } else {
        if (imgURL !== null) {
          this.imageToSubmit.push(imgURL);
          let image = window.URL.createObjectURL(imgURL);
          this.imagePreView.push({
            image,
            id: this.imageToSubmit.length,
            is_thumbnail: false,
            priority_order: this.imageToSubmit.length,
          });
          this.nearByPlace.image = null;
          setTimeout(() => {
            document.querySelector(".has-icon").click();
          }, 500);
        }
      }
    },
  },
};
</script>

<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <h4>
          {{ this.currentProps.isEdit ? "Update" : "Add New" }} Near By Place
        </h4>
        <hr />
      </div>
      <div class="col-md-6">
        <b-form-group
          class="mb-3 form-label"
          label="Category"
          label-for="category"
        >
          <template slot="label">
            Category <span class="text-danger">*</span>
          </template>
          <multiselect
            v-model="nearByPlace.category"
            track-by="id"
            label="name"
            placeholder="Select category"
            :options="categoryOption"
            :multiple="true"
            :taggable="true"
            :show-labels="false"
            :class="{
              'is-invalid': submitted && $v.nearByPlace.category.$error,
            }"
          >
            <template slot="singleLabel" slot-scope="{ option }"
              ><strong> {{ option.name }}</strong></template
            >
          </multiselect>
          <div
            v-if="submitted && $v.nearByPlace.category.$error"
            class="invalid-feedback"
          >
            <span v-if="!$v.nearByPlace.category.required"
              >Category is required.</span
            >
          </div>
        </b-form-group>
      </div>
      <div class="col-md-6">
        <b-form-group class="mb-3" label="Name" label-for="nearByPlace">
          <template slot="label">
            Name <span class="text-danger">*</span>
          </template>
          <b-form-input
            id="nearByPlace"
            type="text"
            autocomplete="off"
            placeholder="Ex : Place Name"
            v-model="nearByPlace.name"
            :class="{
              'is-invalid': submitted && $v.nearByPlace.name.$error,
            }"
          ></b-form-input>
          <div v-if="submitted" class="invalid-feedback">
            <span v-if="!$v.nearByPlace.name.required">Name is required.</span>
          </div>
        </b-form-group>
      </div>
      <div class="col-md-12">
        <span class="text-bold text-uppercase text-dark">Google Details</span>
        <hr />
      </div>
      <div class="col-md-3">
        <b-form-group class="mb-3" label="Address" label-for="g_address">
          <template slot="label">Address</template>
          <b-form-input
            id="g_address"
            type="text"
            autocomplete="off"
            v-model="nearByPlace.g_address"
          >
          </b-form-input>
        </b-form-group>
      </div>
      <div class="col-md-3">
        <b-form-group class="mb-3" label="Address" label-for="g_distance">
          <template slot="label">Distance</template>
          <b-form-input
            id="g_distance"
            type="text"
            autocomplete="off"
            v-model="nearByPlace.g_distance"
          >
          </b-form-input>
        </b-form-group>
      </div>
      <div class="col-md-3">
        <b-form-group class="mb-3" label="latitude" label-for="g_latitude">
          <template slot="label">Latitude</template>
          <b-form-input
            id="g_latitude"
            type="text"
            autocomplete="off"
            v-model="nearByPlace.g_latitude"
          >
          </b-form-input>
        </b-form-group>
      </div>
      <div class="col-md-3">
        <b-form-group class="mb-3" label="longitude" label-for="g_longitude">
          <template slot="label">Longitude</template>
          <b-form-input
            id="g_longitude"
            type="text"
            autocomplete="off"
            v-model="nearByPlace.g_longitude"
          >
          </b-form-input>
        </b-form-group>
      </div>
      <div class="col-md-3">
        <b-form-group
          class="mb-3"
          label="phone_number"
          label-for="g_phone_number"
        >
          <template slot="label">Phone Number</template>
          <b-form-input
            id="g_phone_number"
            type="text"
            autocomplete="off"
            v-model="nearByPlace.g_phone_number"
          >
          </b-form-input>
        </b-form-group>
      </div>
      <div class="col-md-3">
        <b-form-group class="mb-3" label="website" label-for="g_website">
          <template slot="label">Website</template>
          <b-form-input
            id="g_website"
            type="text"
            autocomplete="off"
            v-model="nearByPlace.g_website"
          >
          </b-form-input>
        </b-form-group>
      </div>
      <div class="col-md-3">
        <b-form-group class="mb-3" label="g_rating" label-for="g_website">
          <template slot="label">Google Rating</template>
          <b-form-input
            id="g_rating"
            type="text"
            autocomplete="off"
            v-model="nearByPlace.g_rating"
          >
          </b-form-input>
        </b-form-group>
      </div>
      <div class="col-md-3">
        <b-form-group
          class="mb-3"
          label="user_ratings_total"
          label-for="g_website"
        >
          <template slot="label">User Rating</template>
          <b-form-input
            id="g_user_ratings_total"
            type="text"
            autocomplete="off"
            v-model="nearByPlace.g_user_ratings_total"
          >
          </b-form-input>
        </b-form-group>
      </div>
      <div class="col-md-6">
        <div class="mb-3">
          <label for="g_opening_time">
            <span slot="label">Opening Time</span>
          </label>
          <tinymce
            id="tinyMce-editor"
            v-model="nearByPlace.g_opening_time"
            :plugins="plugins"
            :toolbar="toolbar"
            :other_options="options"
          ></tinymce>
        </div>
      </div>
      <div class="col-md-6">
        <div class="mb-3">
          <label for="description">
            <span slot="label"
              >Description <span class="text-danger">*</span></span
            >
          </label>
          <tinymce
            id="tinyMce-editor1"
            v-model="nearByPlace.description"
            :plugins="plugins"
            :toolbar="toolbar"
            :other_options="options"
          ></tinymce>
        </div>
      </div>
      <div class="col-md-12">
        <label for="Image">
          <span slot="label">Image</span>
        </label>
        <draggable
          class="row"
          v-model="imagePreView"
          v-bind="dragOptions"
          @change="onChoose"
          :disabled="!currentProps.isEdit"
        >
          <div
            class="col-md-3"
            v-for="(image, index) in imagePreView"
            :key="index"
          >
            <div class="d-flex align-items-start mb-3">
              <img
                class="rounded sub-category-img object-fit"
                alt="hotel_info_image"
                :src="typeof image.image !== null || '' ? image.image : ''"
                :id="image.id"
                data-holder-rendered="true"
                :class="currentProps.isEdit ? 'cursor-move' : ''"
              />
              <div class="ms-2" v-if="currentProps.isEdit">
                <div class="form-check">
                  <input
                    :disabled="imagePreView.length == 1 && image.is_thumbnail"
                    class="form-check-input"
                    type="checkbox"
                    :id="image.is_thumbnail"
                    v-model="image.is_thumbnail"
                    v-b-popover.hover="'Use as thumbnail image'"
                    @change="changeThumbnailImageStatus(image)"
                  />
                </div>
                <i
                  class="mdi mdi-trash-can fs-5 text-danger"
                  v-if="imagePreView.length !== 1 && !image.is_thumbnail"
                  slot="label"
                  @click="deleteImage(image, index)"
                ></i>
              </div>
            </div>
          </div>
          <div
            class="col-md-3"
            draggable="true"
            v-if="!isNearByPlaceBtnLoading"
          >
            <div class="position-relative plus-icon">
              <VueDropify
                @upload="changeNearByPlaceImage($event)"
                :src="nearByPlace.image"
                message="Drop image or click here to select"
                id="infoServices_images"
                class="sub-category-img mb-3"
              />
              <i class="bx bx-plus fs-1"></i>
            </div>
          </div>
          <div class="col-md-3 placeholder-glow" v-if="isNearByPlaceBtnLoading">
            <p class="placeholder placeholder-lg sub-category-img"></p>
          </div>
        </draggable>
      </div>
      <hr />
      <div class="col-md-12">
        <b-button
          v-if="$route.path == '/near-by-place'"
          class="float-end ms-2"
          variant="outline-primary"
          type="reset"
          @click="cancelSubmit"
          >Cancel
        </b-button>
        <b-button
          v-if="this.currentProps.isEdit === false"
          class="float-end ms-2"
          variant="outline-primary"
          type="submit"
          @click="saveAndAddNew"
          :class="{
            disabled: isSaveAndAddNew === true && is_btn_loading,
          }"
        >
          <i
            v-if="isSaveAndAddNew === true && is_btn_loading"
            class="bx bx-loader bx-spin font-size-16 align-middle me-2"
          ></i
          >Save & Add
        </b-button>
        <b-button
          class="float-end"
          variant="outline-primary"
          type="submit"
          @click="onSubmit"
          :class="{
            disabled: isSaveAndAddNew === false && is_btn_loading,
          }"
        >
          <i
            class="bx bx-loader bx-spin font-size-16 align-middle me-2"
            v-if="isSaveAndAddNew === false && is_btn_loading"
          ></i>
          {{ this.currentProps.isEdit ? "Update" : "Save" }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.sub-category-img {
  min-width: 210px;
  height: 160px;
}
</style>
